/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} FreeInputs */

const en_free = /** @type {(inputs: FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free`)
};

const ar_free = /** @type {(inputs: FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مجاناً`)
};

const de_free = /** @type {(inputs: FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenlos`)
};

const es_free = /** @type {(inputs: FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis`)
};

const fr_free = /** @type {(inputs: FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratuit`)
};

const it_free = /** @type {(inputs: FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratuito`)
};

const ja_free = /** @type {(inputs: FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無料`)
};

const ko_free = /** @type {(inputs: FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`무료`)
};

const pt_br_free = /** @type {(inputs: FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grátis`)
};

const ru_free = /** @type {(inputs: FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Бесплатно`)
};

const th_free = /** @type {(inputs: FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ฟรี`)
};

const tr_free = /** @type {(inputs: FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ücretsiz`)
};

const zh_cn_free = /** @type {(inputs: FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费版`)
};

const zh_tw_free = /** @type {(inputs: FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免費版`)
};

/**
* | output |
* | --- |
* | "Free" |
*
* @param {FreeInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const free = /** @type {((inputs?: FreeInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<FreeInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_free(inputs)
	if (locale === "ar") return ar_free(inputs)
	if (locale === "de") return de_free(inputs)
	if (locale === "es") return es_free(inputs)
	if (locale === "fr") return fr_free(inputs)
	if (locale === "it") return it_free(inputs)
	if (locale === "ja") return ja_free(inputs)
	if (locale === "ko") return ko_free(inputs)
	if (locale === "pt_br") return pt_br_free(inputs)
	if (locale === "ru") return ru_free(inputs)
	if (locale === "th") return th_free(inputs)
	if (locale === "tr") return tr_free(inputs)
	if (locale === "zh_cn") return zh_cn_free(inputs)
	return zh_tw_free(inputs)
});